<!-- @format -->
<script lang="ts">
  import { getStoresContext, type StoresKey } from "~/stores";
  export let backgroundImageDesktop = "";
  export let backgroundImageMobile = "";
  export let backgroundColorOverlay = "";
  export let request_store_key: StoresKey;
  const { viaCDN } = getStoresContext(request_store_key);
</script>

<div class="row">
  {#if backgroundImageDesktop && backgroundImageMobile}
    {#if backgroundColorOverlay}
      <div
        class="gradient"
        style="background-color: {backgroundColorOverlay};" />
    {/if}
    <div
      class="bg"
      style="--backgroundImageDesktop = url('{viaCDN(
        backgroundImageDesktop,
      )}'); --backgroundImageMobile = url('{viaCDN(backgroundImageMobile)}')" />
  {/if}
  <div class="col-12 px-0">
    <div class="container main">
      <slot />
    </div>
  </div>
</div>

<style lang="scss">
  @media screen and (max-width: 1199px) {
    .container {
      max-width: none;
    }
  }
  .row {
    position: relative;
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--backgroundImageMobile);
    background-repeat: no-repeat;
    background-size: cover;
    @media only screen and (min-width: 992px) {
      background: var(--backgroundImageDesktop);
    }
  }
  .gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  .main {
    z-index: 3;
    position: relative;
  }
</style>
